





import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { AudioBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';

@Component({
  graphqlData: gql`
    fragment AudioBlockData on AudioBlock {
      id
      title
      audioFileUrl
    }
  `,
})
export default class AudioBlock extends mixins(PageBlockMixin<AudioBlockDataFragment>()) {
}
